export default function(date) {
    //Valid date is an object that is Date and that can be converted to milliseconds via getTime().
    return date.constructor === Date && !isNaN(date.getTime());
}
